import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment'
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';



@Component({
  selector: 'app-studentliveclass',
  templateUrl: './studentliveclass.component.html',
  styleUrls: ['./studentliveclass.component.css']
})
export class StudentliveclassComponent implements OnInit {

  Submitted:boolean = false;
  ClientID="5UjGL2diQJ2teUQEAqfgSw";
  ClientSecret="WnyE2v2tKaEf6Z8kHPgnNQOt8rkZ1kgs";
  
  code:any;
  apiKey="tvqkYyygRHm-LTDNuQGG_Q";
  apiSecret="2FS4v0Gjwr6zC5CRCm2awt2vrBQxI4PchJNl";
  meetingNumber:any; // always generate new when requested or user will input
  role = 1;
  //leaveUrl = this.globalHelper.WebUrl+"liveclass"; // Your redirect Url, when meeting over
  userName = this.globalHelper.GetLoginToken().FirstName;
  userEmail = '';
  meetingPassWord = ''; // set default meeting password here
  joinUrl = "";
  posting:boolean= false;
  meetingCreated: boolean = false;
  ToDate=new Date(); 
  
  constructor(private learningservice:LearningService,private LookupService: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService,private _sanitizer: DomSanitizer) { }

  
    SearchModel = {    
      StaffID:0,
      ClassID:0,
      SectionID:0,
      CurrentIndex: 0,
      PageSize: 20,
   };
   StartDateTime:any;
   GetStartDate(item){
    this.StartDateTime=new Date(item.StartDateTime);
    item.StartDateTime=new Date(this.StartDateTime);
    return  item.StartDateTime;
   }
   EndDateTime:any;
 GetEndDate(item){
  this.StartDateTime=new Date(item.StartDateTime);
  item.EndDateTime=new Date(this.StartDateTime.getTime() + item.Duration*60000);
  return  item.EndDateTime;
 }
   ClearSearch(){
     this.SearchModel.ClassID=0;
     this.SearchModel.SectionID=0;
     this.SearchModel.StaffID=0;
     this.LiveClassList=[];
     this.pageSizes();
   }
   Content: '';
   
LiveClassList=[];
 GetAllLiveClass() {
   this.spinnerService.show();
   this.SearchModel.CurrentIndex = this.currentPage;
   this.SearchModel.PageSize = this.pageSize;
   this.learningservice.GetStudentLiveClass(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
     this.LiveClassList = data.LiveClassList;
     this.spinnerService.hide();
     this.globalHelper.CheckActionStatus(data);
     this.recordCount = 0;
     if (data.LiveClassList != null && data.LiveClassList.length > 0) {
         this.recordCount = data.LiveClassList[0].RecordCount;
     }
     this.numberOfPages();
   });
 };


 MPGCode:any;
 LearningModel={
  LiveClassID:0
 }
 joinMeeting(item) {
  this.LearningModel.LiveClassID = item.LiveClassID;  
  this.spinnerService.show();
  this.learningservice.CreateMeetingCode(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
     this.MPGCode=data.MeetingDetails.MPGCode;
     var url = this.globalHelper.WebZoomUrl+"auth?MPGCode="+ this.MPGCode;
    
      this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
      
    }
   
   
    this.spinnerService.hide();
  });
};
embedURL(url){
  return this._sanitizer.bypassSecurityTrustResourceUrl(url); 
 
}
  ngOnInit() {
     this.GetAllLiveClass();
  }




  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
   this.totalPages = Math.ceil(this.recordCount / this.pageSize);
   }

   nextPage() {
   this.currentPage = this.currentPage + 1;
   }

   pageSizes() {
   this.currentPage = 1;
   this.recordCount = 0;
   this.totalPages = 0;
   }
 
}





